import { Blockquote, Stack, Text } from "@mantine/core";
import type { PressQuote as PressQuoteType } from "@/content/types";

export function PressQuote({ quote }: { quote: PressQuoteType }) {
  return (
    <Blockquote color="indigo" cite={quote.author ?? quote.outlet} p="md">
      <Stack gap={4}>
        <Text>{quote.quote}</Text>
        <Text size="xs" c="dimmed">
          {quote.outlet}
          {quote.date && ` · ${quote.date}`}
        </Text>
      </Stack>
    </Blockquote>
  );
}
